import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
  TextField,
  Button,
  LinearProgress,
  Paper,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
} from '@mui/material';

import { AxlButton } from '../../components/AxlButton';
import { insertMap, getMap } from '../../repositories/HttpRepository';

const useStyles = makeStyles()({
  root: {
    marginTop: 20,
    minWidth: 300,
  },
  tableList: {
    minWidth: '300px',
    '& .MuiTableRow-root.MuiTableRow-hover:hover': {
      cursor: 'pointer',
    },
  },
  nameInput: {
    '& .MuiInputBase-input': {
      minWidth: 300,
      padding: '8px',
    },
  },
  loading: {
    width: '100%',
  },
  btn: {
    marginLeft: '5px',
  },
});

const MapTools = ({ geojson, selectedId }) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [openDialogName, setOpenDialogName] = useState(false);
  const [openList, setOpenList] = useState(false);
  const [nameValue, setNameValue] = useState('');
  const [listMap, setListMap] = useState([]);
  const saveAction = () => {
    if (geojson && geojson.length > 0) {
      const data = {
        features: geojson,
        name: nameValue,
      };
      insertMap(data).then((resp) => {
        setOpenDialogName(false);
        if (resp.data) {
          navigate(`/maps/${resp.data}`);
        }
      });
    }
  };
  const loadListMap = () => {
    getMap().then((resp) => {
      if (resp.ok) {
        setListMap(resp.data);
      }
    });
  };
  const handleClick = (event, id) => {
    // console.log('id', id);
    navigate(`/maps/${id}`);
    setOpenList(false);
  };

  return (
    <div>
      <AxlButton
        onClick={() => {
          navigate('/maps');
        }}
        variant="contained"
        color="primary"
      >
        New
      </AxlButton>
      <AxlButton
        className={classes.btn}
        onClick={() => {
          loadListMap();
          setOpenList(true);
        }}
        variant="contained"
        color="primary"
      >
        List
      </AxlButton>
      {!selectedId && (
        <AxlButton
          className={classes.btn}
          onClick={() => {
            setOpenDialogName(true);
          }}
          variant="contained"
          color="secondary"
        >
          Save
        </AxlButton>
      )}
      <Dialog open={openDialogName} onClose={() => setOpenDialogName(false)} aria-labelledby="form-dialog-title" maxWidth="sm">
        <DialogTitle id="form-dialog-title" className={classes.DialogTitle}>
          <Typography variant="h" className={classes.Title}>
            Name of this map
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.DialogContent}>
          <TextField
            variant="outlined"
            className={classes.nameInput}
            onChange={(e) => {
              setNameValue(e.target.value);
            }}
            value={nameValue}
          />
        </DialogContent>
        <DialogActions className={classes.DialogAction}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              saveAction();
            }}
          >
            Save
          </Button>
          <Button variant="outlined" color="primary" onClick={() => setOpenDialogName(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openList} onClose={() => setOpenList(false)} aria-labelledby="form-dialog-title" maxWidth="sm">
        <DialogTitle id="form-dialog-title" className={classes.DialogTitle}>
          <Typography variant="h" className={classes.Title}>
            List all map
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.DialogContent}>
          {listMap.length === 0 && <LinearProgress color="primary" className={classes.loading} />}
          <TableContainer component={Paper}>
            <Table className={classes.tableList} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell align="right">Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listMap.length > 0 &&
                  listMap.map((row) => (
                    <TableRow key={row.name} selected={selectedId === row.id} hover onClick={(event) => handleClick(event, row.id)}>
                      <TableCell component="th" scope="row">
                        {row.id}
                      </TableCell>
                      <TableCell align="right">{row.name}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions className={classes.DialogAction}>
          <Button variant="outlined" color="primary" onClick={() => setOpenList(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default React.memo(MapTools);
